export const sortByDate = (a: any, b: any, order: 'asc' | 'desc') => {
  if (order === 'asc') {
    // @ts-ignore
    return new Date(a) - new Date(b);
  } else {
    // @ts-ignore
    return new Date(b) - new Date(a);
  }
};
